import {Dispatch} from 'react'

// type lifted from https://github.com/nathanbuchar/react-hook-thunk-reducer/blob/master/types/thunk-reducer.d.ts
export interface ThunkDispatch<S, A> {
  <
    Action extends (dispatch: ThunkDispatch<S, A>, getState: () => S) => unknown
  >(
    action: Action
  ): ReturnType<Action>
  (value: A): void
}

export const thunkMiddleware =
  <S, A>(storeAPI: {getState: () => S; dispatch: ThunkDispatch<S, A>}) =>
  (next: Dispatch<A>) =>
  (action: A) => {
    // If the "action" is actually a function instead...
    if (typeof action === 'function') {
      // then call the function and pass `dispatch` and `getState` as arguments
      return action(storeAPI.dispatch, storeAPI.getState)
    }

    // Otherwise, it's a normal action - send it onwards
    return next(action)
  }
